import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { PrintDevice } from './printer';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PrintDeviceType } from '../types';
import { PrinterProductOptType } from '../types';
import { ProductType } from '../types';

const _schema = {
    'name': 'PRINTERPRODUCT',
    'fields': [
        { name: 'status', type: 'string', default: 'AC' },
        { name: 'printer', type: 'objid' },
        { name: 'product', type: 'objid' },
    ],
    relate: [
        { direction: '>', target: 'PRINTER', by: 'printer', name: 'printer', reason: 'printer', child: false, class: PrintDeviceType },
        { direction: '>', target: 'PRODUCT', by: 'product', name: 'product', reason: 'product', child: false, class: ProductType },
        { direction: '<', target: 'PRINTERPRODUCTOPT', by: 'product', name: 'option', reason: 'options', child: true, class: PrinterProductOptType },
    ],
} as const;

const _PrinterProductClass = CreateObject(_schema);
if (!_PrinterProductClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PrinterProduct extends _PrinterProductClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PrinterProduct {
        return this._Copy(store) as PrinterProduct;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'printer' && related instanceof PrintDevice){
            if (related === this.printer){
                related.AddProduct(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.printer){
            if ((this.status == 'DE') && !this.Commited){
                this.printer.DelProduct(this);
            }
            else {
                this.printer.DoRefresh(this.table);
            }
        }
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
